import * as constants from '../constants/ActionTypes';
import { contactPage } from '../constants/UtilVariables';

const initialState = {
  pageName: contactPage.contactUs, // the default page name: should be contactUs
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.CONTACT_LOCATION_CHANGE :
      return Object.assign({}, state, { pageName: action.payload.pageName });
    case constants.RECEIVE_EMAIL_RESPONSE_NO_INTENT:
      return Object.assign({}, state, { pageName: contactPage.success });
    default :
      return state;
  }
}
